import { FormikValues } from 'formik';

import { PASSWORD_MIN_LENGTH } from 'app/design-system/components/Input/constants';
import { isValidPhoneNumber } from 'app/design-system/components/PhoneInput/phone-input-helpers';
import type { tFunction } from 'app/lang';

import { PASS_FORM_VALUES } from '../../constants';

import dictionary from './validation.dictionary.json';

type ValidateError = {
  phoneNumber?: string;
  code?: string;
  newPass?: string;
  confirmPass?: string;
};

type PhoneNumberValidation = (t: tFunction) => (values: FormikValues) => ValidateError;

export const validatePhoneNumber: PhoneNumberValidation = (t) => {
  return (values) => {
    const errors: ValidateError = {};
    const { phoneNumber } = values;

    if (!isValidPhoneNumber(phoneNumber)) {
      errors.phoneNumber = t(dictionary.invalidPhoneNumber);
    }

    return errors;
  };
};

type PasswordValidation = (t: tFunction) => (values: typeof PASS_FORM_VALUES) => ValidateError;

export const validatePass: PasswordValidation = (t) => {
  return (values) => {
    const errors: ValidateError = {};
    const { newPass, login } = values;

    if (newPass === login) {
      errors.newPass = t(dictionary.passNotEqualsPhone);
    }

    if (newPass.length < PASSWORD_MIN_LENGTH) {
      errors.newPass = t(dictionary.passMinLength, { count: PASSWORD_MIN_LENGTH });
    }

    return errors;
  };
};
